import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

/*  eslint-disable jsx-a11y/href-no-hash */
/*  eslint-disable jsx-a11y/anchor-has-content */
class Register extends Component {
    render() {
        return (
            <Scrollbars>
                <div className="register-container full-height sm-p-t-30">
                    <div className="d-flex justify-content-center flex-column full-height">
                        <img src="temp/img/logo.png"
                             alt="logo"
                             data-src="temp/img/logo.png"
                             data-src-retina="temp/img/logo_2x.png"
                             width="78"
                             height="22"
                        />
                        <h3>Budgetti is love, Budgetti is life</h3>
                        <p>
                            Create an account or do that Facebook stuff.
                        </p>
                        <form id="form-register" className="p-t-15">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group form-group-default">
                                        <label>First Name</label>
                                        <input type="text"
                                               name="fname"
                                               placeholder="John"
                                               className="form-control"
                                               required
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group form-group-default">
                                        <label>Last Names</label>
                                        <input type="text"
                                               name="lname"
                                               placeholder="Smith"
                                               className="form-control"
                                               required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group-default">
                                <label>Pages User name</label>
                                <input type="text"
                                       name="uname"
                                       placeholder="yourname.pages.com (this can be changed later)"
                                       className="form-control"
                                       required
                                />
                            </div>
                            <div className="form-group form-group-default">
                                <label>Password</label>
                                <input type="password"
                                       name="pass"
                                       placeholder="Minimum of 4 Charactors"
                                       className="form-control"
                                       required
                                />
                            </div>
                            <div className="form-group form-group-default">
                                <label>Email</label>
                                <input type="email"
                                       name="email"
                                       placeholder="We will send loging details to you"
                                       className="form-control"
                                       required
                                />
                            </div>
                            <div className="row m-t-10">
                                <div className="col-lg-6">
                                    <p><small>I agree to the <a href="#" className="text-info">Pages Terms</a> and <a href="#" className="text-info">Privacy</a>.</small></p>
                                </div>
                                <div className="col-lg-6 text-right">
                                    <a href="#" className="text-info small">Help? Contact Support</a>
                                </div>
                            </div>
                            <button className="btn btn-primary btn-cons m-t-10" type="submit">Create a new account</button>
                        </form>
                    </div>
                </div>
                <div className="full-width">
                    <div className="register-container m-b-10 clearfix">
                        <div className="m-b-30 sm-m-t-20 sm-p-r-15 sm-p-b-20 clearfix d-flex-md-up">
                            <div className="col-md-2 no-padding d-flex align-items-center">
                                <img src="temp/img/demo/pages_icon.png"
                                     alt=""
                                     className=""
                                     data-src="temp/img/demo/pages_icon.png"
                                     data-src-retina="temp/img/demo/pages_icon_2x.png"
                                     width="60"
                                     height="60"
                                />
                            </div>
                            <div className="col-md-9 no-padding d-flex align-items-center">
                                <p className="hinted-text small inline sm-p-t-10">No part of this website or any of its contents may be reproduced, copied, modified or adapted, without the prior written consent of the author, unless otherwise indicated for stand-alone materials.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Scrollbars>
        );
    }
}

export default Register;


// WEBPACK FOOTER //
// ./src/components/base/public/register/register.js